import React from "react";

const map = require("./images/map-usa.jpg")

const states = [
    { name: "California", top: "40%", left: "20%" },
    { name: "Texas", top: "60%", left: "50%" },
    { name: "New York", top: "30%", left: "80%" },
];

const MapSection = () => {
    return (
      <section className="bg-white py-10">
      <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
      
        <div className="max-w-xl mt-5">
          <h3 className="text-gray-700 text-3xl font-extrabold sm:text-4xl">
          Expanding Our Reach Across the Nation
          </h3>
          <p className="mt-3 text-gray-500">
          We are proud to serve communities in multiple states, delivering quality services that make a difference. 
                As we grow, our goal is to expand our presence to even more states, connecting with more people and businesses 
                who share our vision of excellence.
          </p>
          <p className="ml-4 text-gray-600 list-disc my-3 font-semibold">
          Our commitment to growth means building strong partnerships, embracing innovation, 
                and working tirelessly to achieve nationwide impact. Stay tuned as we continue to reach new milestones!
            </p>
            <a
            href="#appointment"
            className="mt-3 md:mt-0 text-lg inline-block py-4 md:ml-2 px-5 text-gray-100 font-medium bg-sky-500 duration-150 hover:bg-red-400 active:bg-red-400 rounded-full"
          >
            Find handyman near me
          </a>
        </div>
        <div className="relative w-full max-w-xl mx-auto mt-10 p-4">
            {/* Map Image */}
            <img 
                src={map} 
                alt="Map" 
                className="w-full h-auto object-cover rounded-lg shadow-lg"
            />
            {/* State Markers */}
            {states.map((state, index) => (
                <div
                    key={index}
                    className="absolute flex items-center justify-center bg-red-500 text-white text-xs font-semibold rounded-full w-20 h-20 transform -translate-x-1/2 -translate-y-1/2"
                    style={{ top: state.top, left: state.left }}
                >
                    {state.name}
                </div>
            ))}
        </div>
      </div>
    </section>

       
    );
};

export default MapSection;
